export default __webpack_public_path__ + "static/media/Nikhil Karanam.4ec959c4.jpg";